<script>
    export let isFullscreen;
</script>

{#if isFullscreen}
    <i class="fa-thin fa-compress"></i>
{:else}
    <i class="fa-thin fa-expand"></i>
{/if}
